import { Document, Image, Page, StyleSheet, Text, View, Link, BlobProvider } from "@react-pdf/renderer"
import { Font } from "@react-pdf/renderer";
import ModalInDrawer from "../../ui/ModalInDrawer";
import { PDFViewer } from "@react-pdf/renderer";
import PoppinsBold from "../../../assets/fonts/PoppinsBold.ttf";
import PoppinsMedium from "../../../assets/fonts/PoppinsMedium.ttf";
import PoppinsLight from "../../../assets/fonts/PoppinsLight.ttf";
import logoAllSavfeBlanco from "../../../assets/logos/logoAllSavfeBlanco.png"
import { formatDateString } from "../../../helpers/datesHelper";
import { getFinalPriceCotDrawer } from "../../../helpers/pricesCotizacion";
import OpenSansBold from "../../../assets/fonts/OpenSans/OpenSansBold.ttf"
import OpenSansSemiBold from "../../../assets/fonts/OpenSans/OpenSansSemiBold.ttf"
import OpenSansMedium from "../../../assets/fonts/OpenSans/OpenSansMedium.ttf"
import OpenSansRegular from "../../../assets/fonts/OpenSans/OpenSansRegular.ttf"
import OpenSansLight from "../../../assets/fonts/OpenSans/OpenSansLight.ttf"
import VectorAllsavfe from "../../../assets/images/VectorAllsavfe.png"
import diagonalAllsavfe from "../../../assets/images/diagonalAllsavfe.png"
import ArrowAllsavfe from "../../../assets/images/ArrowAllsavfe.png"
import ClipAllSavfe from "../../../assets/images/ClipAllSavfe.png"

import { CapitalizeEachWord, CapitalizeFirstLetter } from "../../../utils/CapitalizeLetters";

import DMSansBoldFont from "../../../assets/fonts/DMSans-Bold.ttf";
import DMSansRegularFont from "../../../assets/fonts/DMSans-Regular.ttf";
import { BorderColor } from "@mui/icons-material";
import { FormatDateString } from "../../../utils/FormatDate";

import { CalculateFinalPrice } from "../../../utils/metadata/CalculatePrice";
import { FaDownload } from "react-icons/fa";
import { handleDownloadBlobPDF } from "../../../utils/pdf/handleDownloadBlobPDF";
import { sanitizeNombreServicioPdf } from "../../../utils/pdf/sanitizeNombreServicioPdf";
import CalcularPrecioPais from "../../../utils/preciosPaises/calcularPrecioPais";
import ObtenerMultiplicador from "../../../utils/preciosPaises/obtenerMultiplicador";


const brandName = "AllSavfe"

Font.register({
  family: "OpenSans",
  fonts: [
    { src: OpenSansBold, fontWeight: "bold" },
    { src: OpenSansSemiBold, fontWeight: "semibold" },
    { src: OpenSansMedium, fontWeight: "medium" },
    { src: OpenSansRegular, fontWeight: "regular" },
    { src: OpenSansLight, fontWeight: "light" },
  ],
});

Font.register({
  family: "Poppins",
  fonts: [
    { src: PoppinsBold, fontWeight: "bold"},
    { src: PoppinsMedium, fontWeight: "normal"},
    { src: PoppinsLight, fontWeight: "light"}
  ]
})

const lila = "#9074FC"
const blue = "#2334DE"
const black = "#030712"
const darkBlue = "#0F1661"
const pink = "#C13DF3"
const gray = "#F1F8FB"
const grayBorder = "#D1D1D1"
const white = "#FFFFFF"

const infoBar = StyleSheet.create({

  item: {
    display: "flex", 
    flexDirection: "row", 
    alignItems: "center", 
    justifyContent: "center", 
    minWidth: "194px",
    minHeight: "32px",
    gap: "8px"
  },

  title: {
    fontFamily: "OpenSans", 
    fontWeight: "medium", 
    color: black,
  },

  dataInput: {
    backgroundColor: white, 
    display: "flex", 
    flexDirection: "center", 
    justifyContent: "center", 
    minWidth: "132px", 
    height: "32px", 
    borderRadius: "4px",
    paddingHorizontal: "5px",
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderRightColor: "#E0E0E0",
    borderBottomColor: "#E0E0E0",
  },

  barData: {
    fontFamily: "OpenSans", 
    fontWeight: "medium", 
    color: darkBlue,
    margin: "auto", 
    paddingTop: "2px"
  },

})

const PDFAllSavfe = ({ open, igv, onClose, title, descuento, cotizacionData, allServiciosList, serviciosList, pagosList,  moneda, tipoCambio, paises }) => {

  // const subtotal = serviciosList.reduce((acc, value) => {
  //   const precio = value.customPriceActive
  //     ? value.customPrice * value.numeroItems
  //     : value.servicio.preciosUnitarios?.find(
  //         (pU) => pU.plan.id === value.planServicio.id
  //     )?.precio * value.numeroItems || 0;
  //   return acc + precio;
  // }, 0);

  const subtotal = serviciosList.reduce((acc, value) => {
    // Obtener el precio base
    const precioBase = value.customPriceActive
        ? value.customPrice * value.numeroItems
        : value.servicio.preciosUnitarios?.find(
            (pU) => pU.plan.id === value.planServicio.id
        )?.precio * value.numeroItems || 0;

    // Aplicar multiplicador del país solo si no es customPrice
    const precioConPais = value.customPriceActive
        ? precioBase
        : CalcularPrecioPais({
            precio: precioBase,
            multiplicador: ObtenerMultiplicador({
                pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
                paises: paises
            })
        });

    // Aplicar descuento si existe
    let precioFinal = precioConPais;
    if (value.tipoDescuento === "Porcentaje") {
        precioFinal -= precioConPais * (value.montoDescuento / 100);
    } else if (value.tipoDescuento === "Fijo") {
        precioFinal -= value.montoDescuento * value.numeroItems;
    }

    return acc + precioFinal;
}, 0);

  const calculateServicePrice = (servicio) => {
    if (servicio.customPriceActive) {
      // Si el precio personalizado está activo
      return servicio.customPrice * servicio.numeroItems;
    } else {
      // Buscar el precio del plan correspondiente
      const unitPrice =
        servicio.servicio.preciosUnitarios?.find(
          (pU) => pU.plan.id === servicio.planServicio.id
        )?.precio || 0;
      return unitPrice * servicio.numeroItems;
    }
  };

  // Versión antigua
  // const calculateDiscount = () => {
  //   if (serviciosList && serviciosList.length > 0) {
  //     // Calcular el descuento total iterando sobre la lista de servicios
  //     const totalDescuento = serviciosList.reduce((total, servicio) => {
  //       const { tipoDescuento, montoDescuento } = servicio;
  
  //       // Calcular el precio del servicio usando la nueva función
  //       const precio = calculateServicePrice(servicio);
  
  //       // Asegurarse de que montoDescuento sea un número válido
  //       const descuentoNumerico = Number(montoDescuento) || 0;
  
  //       // Calcular el monto del descuento según el tipo
  //       const monto =
  //         tipoDescuento === "Porcentaje"
  //           ? (precio * descuentoNumerico) / 100 // Descuento porcentual
  //           : descuentoNumerico * servicio.numeroItems; // Descuento fijo
  
  //       return total + monto; // Sumar el descuento al total
  //     }, 0);
  
  //     return totalDescuento.toFixed(2); // Formatear a dos decimales
  //   } else {
  //     // Si no hay servicios, retornar un valor por defecto
  //     return "0.00";
  //   }
  // };

  // Versión nueva
  const calculateDiscount = () => {
    if (serviciosList && serviciosList.length > 0) {
      // Calcular el descuento total iterando sobre la lista de servicios
      const totalDescuento = serviciosList.reduce((total, servicio) => {
        const { tipoDescuento, montoDescuento } = servicio;
  
        // Calcular el precio del servicio usando la nueva función
        const precio = calculateServicePrice(servicio);
  
        // Asegurarse de que montoDescuento sea un número válido
        const descuentoNumerico = Number(montoDescuento) || 0;
  
        // Calcular el monto del descuento según el tipo
        let montoDescuentoCalculado = 0;
        if (tipoDescuento === "Porcentaje") {
            // Para descuento porcentual, aplicar al precio con multiplicador del país
            const precioConPais = servicio.customPriceActive
                ? precio
                : CalcularPrecioPais({
                    precio: precio,
                    multiplicador: ObtenerMultiplicador({
                        pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
                        paises: paises
                    })
                });
            montoDescuentoCalculado = (precioConPais * descuentoNumerico) / 100;
        } else if (tipoDescuento === "Fijo") {
            // Para descuento fijo, solo multiplicar por cantidad (sin multiplicador del país)
            montoDescuentoCalculado = descuentoNumerico * servicio.numeroItems;
        }
  
        return total + montoDescuentoCalculado; // Sumar el descuento al total
      }, 0);
  
      return totalDescuento; // Retornar el valor sin formatear para usar en cálculos
    } else {
      // Si no hay servicios, retornar un valor por defecto
      return 0;
    }
  };

  // Destructurar la descripcion por líneas en objetos { key: value }
  const parseDescription = (description) => {
    if (!description || typeof description !== 'string') {
        return [];
    }

    return description.split('\n').map(item => {
        const [key, value] = item.split(':');
        return { 
            key: key ? key.trim() : '',
            value: value ? value.trim() === '✓' ? 'Si' : value.trim() : 'No'
        };
    });
  };

  const descuentoTotal = calculateDiscount()
            
  const totalSinDescuento = subtotal - descuentoTotal;

  const { subtotalSinIGV, igvTotal, totalConIGV } = getFinalPriceCotDrawer({
    serviciosCotizaciones: serviciosList,
    allServiciosList: allServiciosList,
    porcentajeIGV: 18,
    multiplicador: ObtenerMultiplicador({
      pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
      paises: paises
    })
  })

  const calculatePageHeight = () => {
    const header = 108;
    const bar = 40;
    const info = 259;
    const serviceTable = 80;
    const terms = 209;
    const serviceResume = 40;
    const marginBottom = 150;
    const succesCases = 200;
    const footer = 40;

    const staticHeight = header + bar + info + serviceTable + terms + serviceResume;

    const serviciosItemNumbers = serviciosList.length * 56;
    const pagosItemNumbers = pagosList.length * 100;

    // Para cada servicio, calculamos la cantidad de ítems en su descripción
    const serviciosDescripcionNumbers = serviciosList.reduce((total, item) => {

        let descriptionService = []

        if (item.customDescriptionActive) {
            descriptionService = parseDescription(item.customDescriptionText)
        } else {
            descriptionService = parseDescription(item.planServicio.descripcion);
        }

        // Sumar 32 o 48 dependiendo de la longitud de cada ítem en la descripción
        const descriptionHeight = descriptionService.reduce((descTotal, descItem) => {
            return descTotal + (descItem.key.length < 35 ? 40 : 52);
            //return descTotal + (descItem.key.length < 25 ? 32 : 52);
        }, 0);

        return total + descriptionHeight;
    }, 0);

    // Condicional comentado: si el estado de la cotización es "Exito", sumar la altura de los ítems de la descripción.
    const finalHeight = staticHeight + serviciosItemNumbers + pagosItemNumbers + marginBottom + succesCases + footer;
    return finalHeight + serviciosDescripcionNumbers
    //return cotizacionData.estado === "Exito" ? finalHeight + serviciosDescripcionNumbers : finalHeight;
  };

  const dataEmpresa = [
    { subtitle: "Dirección", content: "Cal. Elías Aguirre Nro. 180" },
    { subtitle: "Distrito", content: "Miraflores - Lima" },
    { subtitle: "Sitio web", content: "www.allsavfe.com" },
    { subtitle: "Teléfono", content: "913119546" },
    { subtitle: "Correo", content: "ventas@monstruocreativo.com" },
    { subtitle: "Asesor(a)", content: cotizacionData?.cotizador?.name },
  ]

  const dataCliente = [
    { subtitle: "Razón Social", content: cotizacionData?.cliente?.razonSocial || cotizacionData?.lead?.brandName},
    { subtitle: "RUC", content: cotizacionData?.cliente?.ruc ||  cotizacionData?.lead?.ruc },
    { subtitle: "Dirección", content: cotizacionData?.cliente?.direccion },
    { subtitle: "Distrito", content: cotizacionData?.cliente?.distrito },
    { subtitle: "Teléfono", content: cotizacionData?.cliente?.telefono ||  cotizacionData?.cliente?.telefonoGerente || cotizacionData?.lead?.phone },
    { subtitle: "Encargado(a)", content: cotizacionData?.cliente?.encargadoProyecto},
  ]

  const pdf = (
    <>
      {
        <Document title={`${cotizacionData?.cliente?.razonSocial || cotizacionData?.lead?.leadName} - ${brandName}`}>
          <Page style={{ fontSize: 12 }} size={[842, calculatePageHeight()]}>

            {/* Header */}
            <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", height: "130px", paddingHorizontal: "32", paddingVertical: "48", backgroundColor: blue }}> 
              <View style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "start", width: "460px" }}>
                <View style={{ display: "flex", flexDirection: "col", height: "66px" }}>
                  <Text style={{ color: "white", fontFamily: "Poppins", fontWeight: "bold", fontSize: "38px" }}>
                    {cotizacionData?.tipo === "Factura" ? cotizacionData?.tipo : "Cotización"}
                  </Text>

                  <Text style={{ color: white, fontFamily: "OpenSans", fontWeight: "medium", fontSize: "16px" }}>
                    AGENCIA DE DESARROLLO WEB ALLSAVFE S.A.C
                  </Text>
                </View>
              </View>
              <Image src={logoAllSavfeBlanco} style={{ width: "214.03px", height: "48px" }}/>
            </View>
            
            {/* InfoBar */}
            <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", backgroundColor: gray, height: "64px", paddingHorizontal: "48px", paddingVertical: "8px" }}>
              <View style={infoBar.item}>
                <View style={{
                  width: 8,
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: blue,
                }} />
                <Text style={infoBar.title}>
                  Fecha:
                </Text>
                <View style={infoBar.dataInput}>
                  <Text style={infoBar.barData}>
                    {cotizacionData?.createdAt && formatDateString(cotizacionData?.createdAt)}
                  </Text>
                </View>
              </View>

              <View style={infoBar.item}>
                <View style={{
                  width: 8,
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: blue,
                }} />
                <Text style={infoBar.title}>
                  Válido hasta:
                </Text>
                <View style={infoBar.dataInput}>
                  <Text style={infoBar.barData}>
                    {cotizacionData?.fechaCotizacionLimite && formatDateString(cotizacionData?.fechaCotizacionLimite)}
                  </Text>
                </View>
              </View>
            </View>

            {/* Data empresa y cliente */}
            <View style={{ display: "flex", flexDirection: "col", justifyContent: "space-between", height: "536px", paddingHorizontal: "48px", paddingVertical: "32px", backgroundColor: white }}>

              { /* Cointenedor */ }
              <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "746px", height: "268px" }}>
            
                {/* Datos de la empresa */}
                <View style={{ display: "flex", flexDirection: "column", width: "356px", height: "268px", alignItems: "center", gap: "16px" }}>
                  <Text style={{    
                    fontFamily: "OpenSans", 
                    fontWeight: "medium", 
                    fontSize: "16px", 
                    color: black,
                  }}>
                    Datos de la empresa
                  </Text>
                  
                  <View style={{ display: "flex", flexDirection: "column", width: "356px", height: "232px", alignItems: "center", gap: "8px"}}>
                    {dataEmpresa.map((d, i) => (
                      <View style={{      
                        display: "flex",
                        flexDirection: "row",
                        width: "356px",
                        height: "32px",
                        alignItems: "center",
                        paddingHorizontal: "12px",
                        gap: "8px",
                        backgroundColor: i % 2 !== 0 ? gray : white
                      }}>

                        <Text style={{    
                          fontFamily: "Poppins",
                          fontWeight: "normal",
                          fontSize: "12px",
                          color: lila,
                          minWidth: "20px",
                          paddingLeft: "5px",
                        }}>
                          /
                        </Text>

                        <Text style={{    
                          fontFamily: "OpenSans",
                          fontWeight: "medium",
                          fontSize: "12px",
                          color: darkBlue,
                          minWidth: "80px",
                          gap: "10px"
                        }}>
                          {d.subtitle}
                        </Text>

                        <Text style={{
                          fontFamily: "OpenSans",
                          fontWeight: "bold",
                          fontSize: "12px",
                          color: darkBlue,
                          paddingRight: "8px"
                        }}>
                          :
                        </Text>
                        <View style={{
                          backgroundColor: white,
                          minHeight: 32,
                          minWidth: 212,
                          justifyContent: "center",
                          alignItems: "flex-start",
                          paddingHorizontal: 13,
                          borderRadius: 2,
                          borderRightWidth: 1,
                          borderBottomWidth: 1,
                          borderRightColor: "#E0E0E0",
                          borderBottomColor: "#E0E0E0",
                        }}>
                          <Text style={{
                            fontFamily: "OpenSans",
                            fontWeight: "light",
                            fontSize: "12px",
                            color: black,
                            textAlign: "center",
                          }}>
                            {d.content}
                          </Text>
                        </View>

                      </View>
                    ))}
                  </View>
                </View>

                {/* Datos del cliente */}
                <View style={{ display: "flex", flexDirection: "column", width: "356px", height: "268px", alignItems: "center", gap: "16px" }}>
                  <Text style={{    
                    fontFamily: "OpenSans", 
                    fontWeight: "medium", 
                    fontSize: "16px", 
                    color: black,
                  }}>
                    Datos del cliente
                  </Text>
                  
                  <View style={{ display: "flex", flexDirection: "column", width: "356px", height: "232px", alignItems: "center", gap: "8px"}}>
                    {dataCliente.map((d, i) => (
                      <View style={{      
                        display: "flex",
                        flexDirection: "row",
                        width: "356px",
                        height: "32px",
                        alignItems: "center",
                        paddingHorizontal: "12px",
                        gap: "8px",
                        backgroundColor: i % 2 !== 0 ? gray : white
                      }}>

                        <Text style={{    
                          fontFamily: "Poppins",
                          fontWeight: "normal",
                          fontSize: "12px",
                          color: lila,
                          minWidth: "20px",
                          paddingLeft: "5px"
                        }}>
                          /
                        </Text>

                        <Text style={{    
                          fontFamily: "OpenSans",
                          fontWeight: "medium",
                          fontSize: "12px",
                          color: darkBlue,
                          minWidth: "80px",
                          gap: "10px"
                        }}>
                          {d.subtitle}
                        </Text>

                        <Text style={{
                          fontFamily: "OpenSans",
                          fontWeight: "bold",
                          fontSize: "12px",
                          color: darkBlue,
                          paddingRight: "8px"
                        }}>
                          :
                        </Text>
                        <View style={{
                          backgroundColor: white,
                          minHeight: 32,
                          minWidth: 212,
                          justifyContent: "center",
                          alignItems: "flex-start",
                          paddingHorizontal: 13,
                          borderRadius: 2,
                          borderRightWidth: 1,
                          borderBottomWidth: 1,
                          borderRightColor: "#E0E0E0",  // gris claro
                          borderBottomColor: "#E0E0E0",
                        }}>
                          <Text style={{
                            fontFamily: "OpenSans",
                            fontWeight: "light",
                            fontSize: "12px",
                            color: black,
                            textAlign: "center",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}>
                            {d.content}
                          </Text>
                        </View>

                      </View>
                    ))}
                  </View>
                </View>

              </View>

              {/* Cuentas bancarias */}
              <View style={{ 
                borderRadius: "8px",
                borderWidth: 1,
                borderColor: blue,
                display: "flex", 
                flexDirection: "col", 
                width: "746px", 
                height: "172px", 
                backgroundColor: gray,
                justifyContent: "space-between",
                paddingBottom: "24px"
              }}>

                {/* Cabecera */}
                <View style={{
                  width: "213px",
                  height: "36px",
                  backgroundColor: blue,
                  paddingHorizontal: "24px",
                  paddingVertical: "4px",
                  textAlign: "center",
                  justifyContent: "center",
                  borderTopLeftRadius: "6px",
                  borderBottomRightRadius: "8px",
                }}>
                  <Text style={{
                    fontFamily: "OpenSans",
                    fontWeight: "semibold",
                    fontSize: "16px",
                    color: white,
                  }}>
                    N° Cuentas Bancarias
                  </Text>
                </View>

                {/* Información */}
                <View style={{ width: "698px", height: "92px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  
                  {/* Cuentas Interbank dólares */}
                  <View style={{ width: "332px", height: "92px", display: "flex", flexDirection: "col", gap: "16px", paddingHorizontal: "24px" }}>
                    <View style={{ width: "332px", height: "32px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                      
                      <View style={{ // Punto
                        width: 8,
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: blue,
                      }} />

                      <Text style={{ // Título
                        color: darkBlue, 
                        width: "124px", 
                        height: "34px", 
                        fontFamily: "OpenSans", 
                        fontWeight: "medium", 
                        fontSize: "12px"
                        }}>
                        {"Cuenta Interbank\ndólares"}
                      </Text>
                      
                      <Text style={{
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        fontSize: "12px",
                        color: lila,
                        paddingRight: "8px"
                      }}>
                        :
                      </Text>

                      <View style={{ // Contenido
                        width: "172px", 
                        height: "32px", 
                        backgroundColor: white,
                        display: "flex",
                        flexDirection: "center",
                        justifyContent: "center",
                        borderRadius: "2px",
                        paddingHorizontal: "8px",
                        borderRightWidth: 1,
                        borderBottomWidth: 1,
                        borderRightColor: "#E0E0E0",
                        borderBottomColor: "#E0E0E0",
                      }}>
                        <Text style={{ 
                          color: black, 
                          fontFamily: "OpenSans", 
                          fontWeight: "medium", 
                          fontSize: "12px"
                        }}>
                          200-3004305598
                        </Text>
                      </View>

                    </View>

                    <View style={{ width: "332px", height: "44px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                      
                      <View style={{ // Punto
                        width: 8,
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: blue,
                      }} />

                      <Text style={{ // Título
                        color: darkBlue, 
                        width: "124px", 
                        height: "50px", 
                        fontFamily: "OpenSans", 
                        fontWeight: "medium", 
                        fontSize: "12px"
                        }}>
                        {"Cuenta Interbank\ninterbancaria\ndólares"}
                      </Text>
                      
                      <Text style={{
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        fontSize: "12px",
                        color: lila,
                        paddingRight: "8px"
                      }}>
                        :
                      </Text>

                      <View style={{ // Contenido
                        width: "172px", 
                        height: "32px", 
                        backgroundColor: white,
                        display: "flex",
                        flexDirection: "center",
                        justifyContent: "center",
                        borderRadius: "2px",
                        paddingHorizontal: "8px",
                        borderRightWidth: 1,
                        borderBottomWidth: 1,
                        borderRightColor: "#E0E0E0",
                        borderBottomColor: "#E0E0E0",
                      }}>
                        <Text style={{ 
                          color: black, 
                          fontFamily: "OpenSans", 
                          fontWeight: "medium", 
                          fontSize: "12px"
                        }}>
                          003-200-003004305598-34
                        </Text>
                      </View>

                    </View>
                  </View>
                  
                  {/* Cuentas Interbank soles */}
                  <View style={{ width: "332px", height: "92px", display: "flex", flexDirection: "col", gap: "16px", paddingHorizontal: "24px" }}>
                    <View style={{ width: "332px", height: "32px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                      
                      <View style={{ // Punto
                        width: 8,
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: blue,
                      }} />

                      <Text style={{ // Título
                        color: darkBlue, 
                        width: "124px", 
                        height: "34px", 
                        fontFamily: "OpenSans", 
                        fontWeight: "medium", 
                        fontSize: "12px"
                        }}>
                        {"Cuenta Interbank\nsoles"}
                      </Text>
                      
                      <Text style={{ // Separadpr
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        fontSize: "12px",
                        color: lila,
                        paddingRight: "8px"
                      }}>
                        :
                      </Text>

                      <View style={{ // Contenido
                        width: "172px", 
                        height: "32px", 
                        backgroundColor: white,
                        display: "flex",
                        flexDirection: "center",
                        justifyContent: "center",
                        borderRadius: "2px",
                        paddingHorizontal: "8px",
                        borderRightWidth: 1,
                        borderBottomWidth: 1,
                        borderRightColor: "#E0E0E0",
                        borderBottomColor: "#E0E0E0",
                      }}>
                        <Text style={{ 
                          color: black, 
                          fontFamily: "OpenSans", 
                          fontWeight: "medium", 
                          fontSize: "12px"
                        }}>
                          200-3004305580
                        </Text>
                      </View>

                    </View>

                    <View style={{ width: "332px", height: "44px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                      
                      <View style={{ // Punto
                        width: 8,
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: blue,
                      }} />

                      <Text style={{ // Título
                        color: darkBlue, 
                        width: "124px", 
                        height: "50px", 
                        fontFamily: "OpenSans", 
                        fontWeight: "medium", 
                        fontSize: "12px"
                        }}>
                        {"Cuenta Interbank \ninterbancaria\nsoles"}
                      </Text>
                      
                      <Text style={{ // Separador
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        fontSize: "12px",
                        color: lila,
                        paddingRight: "8px"
                      }}>
                        :
                      </Text>

                      <View style={{ // Contenido
                        width: "172px", 
                        height: "32px", 
                        backgroundColor: white,
                        display: "flex",
                        flexDirection: "center",
                        justifyContent: "center",
                        borderRadius: "2px",
                        paddingHorizontal: "8px",
                        borderRightWidth: 1,
                        borderBottomWidth: 1,
                        borderRightColor: "#E0E0E0",
                        borderBottomColor: "#E0E0E0",
                      }}>
                        <Text style={{ 
                          color: black, 
                          fontFamily: "OpenSans", 
                          fontWeight: "medium", 
                          fontSize: "12px"
                        }}>
                          003-200-003004305598-34
                        </Text>
                      </View>

                    </View>
                  </View>

                </View>
                
              </View>

            </View>

            {/* Sección de tablas servicios y pagos */}
            <View style={{ 
              display: "flex", 
              flexDirection: "col",
              paddingHorizontal: "48px",
              paddingTop: "48px", 
              paddingBottom: "64px", 
              gap: "32px"                           

            }}>
              
              {/* Buenas tardes */}
              <View style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", width: "742px", gap: "12", }}>
                
                <View style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "742px", gap: "12px" }}>
                  <Image src={VectorAllsavfe} style={{ width: "32px", height: "19.61px" }}/>
                  <Text style={{ color: black, fontFamily: "Poppins", fontWeight: "semibold", fontSize: "24px"}}>
                    Buenas tardes {CapitalizeEachWord(
                      cotizacionData?.cliente?.razonSocial || cotizacionData?.lead?.leadName
                    )} {"   "}                
                  </Text>
                </View>

                {/* <View style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
                  <Image src={diagonalAllsavfe} style={{ height: "15px" }}/>
                  <Image src={diagonalAllsavfe} style={{ height: "15px" }}/>
                  <Image src={diagonalAllsavfe} style={{ height: "15px" }}/>
                  <Image src={diagonalAllsavfe} style={{ height: "15px" }}/>
                  <Image src={diagonalAllsavfe} style={{ height: "15px" }}/>
                </View> */}
                
              </View>

              { /* Tabla servicios */}
              <View style={{ display: "flex", flexDirection: "col", width: "746px" }}>
       
                { /* Table head */}
                <View style={{ 
                  display: "flex", 
                  flexDirection: "row", 
                  borderColor: grayBorder,
                  borderWidth: 0.4,
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  overflow: "hidden"
                }}>
                  {/* Servicio */}
                  <View style={{ 
                    width: "147px", 
                    backgroundColor: black,
                    borderColor: grayBorder, 
                    borderWidth: 0.4,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "medium", 
                      fontSize: "12px", 
                      color: white,
                      textAlign: "center"
                    }}>
                      Servicio
                    </Text>
                  </View>

                  {/* Plan */}
                  <View style={{ 
                    width: "58px", 
                    backgroundColor: darkBlue,
                    borderColor: grayBorder, 
                    borderWidth: 0.4,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "medium", 
                      fontSize: "12px", 
                      color: white,
                      textAlign: "center"
                    }}>
                      Plan
                    </Text>
                  </View>

                  {/* Fecha inicio */}
                  <View style={{ 
                    width: "134px", 
                    backgroundColor: darkBlue,
                    borderColor: grayBorder, 
                    borderWidth: 0.4,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "medium", 
                      fontSize: "12px", 
                      color: white,
                      textAlign: "center",
                      lineHeight: 1.2
                    }}>
                      Fecha{"\n"}inicio
                    </Text>
                  </View>

                  {/* Fecha fin */}
                  <View style={{ 
                    width: "134px", 
                    backgroundColor: darkBlue,
                    borderColor: grayBorder, 
                    borderWidth: 0.4,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "medium", 
                      fontSize: "12px", 
                      color: white,
                      textAlign: "center",
                      lineHeight: 1.2
                    }}>
                      Fecha{"\n"}fin
                    </Text>
                  </View>

                  {/* Cantidad */}
                  <View style={{ 
                    width: "85px", 
                    backgroundColor: darkBlue,
                    borderColor: grayBorder, 
                    borderWidth: 0.4,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "medium", 
                      fontSize: "12px", 
                      color: white,
                      textAlign: "center"
                    }}>
                      Cantidad
                    </Text>
                  </View>

                  {/* Precio UD */}
                  <View style={{ 
                    width: "94px", 
                    backgroundColor: darkBlue,
                    borderColor: grayBorder, 
                    borderWidth: 0.4,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "medium", 
                      fontSize: "12px", 
                      color: white,
                      textAlign: "center",
                      padding: "4px"
                    }}>
                      Precio Unit.
                    </Text>
                  </View>

                  {/* Total */}
                  <View style={{ 
                    width: "94px", 
                    backgroundColor: darkBlue,
                    borderColor: grayBorder, 
                    borderWidth: 0.4,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "medium", 
                      fontSize: "12px", 
                      color: white,
                      textAlign: "center"
                    }}>
                      Total
                    </Text>
                  </View>
                </View>

                { /* Rows */}
                <View style={{ 
                  display: "flex", 
                  flexDirection: "column",
                  borderColor: grayBorder,
                  borderWidth: 0.4,
                  borderBottomLeftRadius: 8,
                  borderBottomRightRadius: 8,
                  overflow: "hidden"
                }}>
                  {serviciosList.map((e, index) => (
                    <View style={{ 
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "row", 
                      height: "56px",
                      backgroundColor: index % 2 === 0 ? "white" : gray,
                      ...(index === serviciosList.length - 1 && {
                        borderBottomLeftRadius: 8,
                        borderBottomRightRadius: 8
                      })
                    }}> 

                      <View style={{display: "flex", alignItems: "center", justifyContent: "center", width: "147px", height: "56px", border: 0.4, borderColor: grayBorder}}>
                        <Text style={{fontFamily: "OpenSans", fontWeight: "medium", fontSize: "10px", color: black, textAlign: "center" }}>
                          {sanitizeNombreServicioPdf(e.servicio.name)}
                        </Text>
                      </View>

                      <View style={{display: "flex", alignItems: "center", justifyContent: "center", width: "58px", height: "56px", border: 0.4, borderColor: grayBorder}}>
                        <Text style={{fontFamily: "OpenSans", fontWeight: "medium", fontSize: "10px", color: black, textAlign: "center" }}>
                          {sanitizeNombreServicioPdf(e?.planServicio?.name)}
                        </Text>
                      </View>

                      <View style={{display: "flex", alignItems: "center", justifyContent: "center", width: "134px", height: "56px", border: 0.4, borderColor: grayBorder}}>
                        <Text style={{fontFamily: "OpenSans", fontWeight: "medium", fontSize: "10px", color: black, textAlign: "center" }}>
                          {e.fechaInicio && FormatDateString(e?.fechaInicio)}
                        </Text>
                      </View>

                      <View style={{display: "flex", alignItems: "center", justifyContent: "center", width: "134px", height: "56px", border: 0.4, borderColor: grayBorder}}>
                        <Text style={{fontFamily: "OpenSans", fontWeight: "medium", fontSize: "10px", color: black, textAlign: "center" }}>
                          {e.fechaFin && FormatDateString(e?.fechaFin)}
                        </Text>|
                      </View>
                    
                      <View style={{display: "flex", alignItems: "center", justifyContent: "center", width: "85px", height: "56px", border: 0.4, borderColor: grayBorder}}>
                        <Text style={{fontFamily: "OpenSans", fontWeight: "medium", fontSize: "10px", color: black, textAlign: "center" }}>
                          {e.numeroItems}
                        </Text>
                      </View>

                      <View style={{display: "flex", alignItems: "center", justifyContent: "center", width: "94px", height: "56px", border: 0.4, borderColor: grayBorder}}>
                        <Text style={{fontFamily: "OpenSans", fontWeight: "medium", fontSize: "10px", color: black, textAlign: "center" }}>
                          {moneda + " "}
                          {/* {e?.customPriceActive
                            ? e.customPrice.toFixed(2)
                            : e.servicio.preciosUnitarios?.find(
                                (pU) => pU.plan.id === e.planServicio.id
                            )?.precio.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })} */}
                            {(() => {
                                // Obtener el precio base
                                const precioBase = e?.customPriceActive
                                    ? e.customPrice
                                    : e.servicio?.preciosUnitarios?.find(
                                        (pU) => pU.plan.id === e.planServicio.id
                                    )?.precio || 0;

                        

                                // Calcular el precio según el país solo si no es customPrice
                                const precioConPais = e?.customPriceActive
                                    ? precioBase
                                    : CalcularPrecioPais({
                                        precio: precioBase,
                                        multiplicador: ObtenerMultiplicador({
                                            pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
                                            paises: paises
                                        })
                                    });

                                // Convertir a la moneda objetivo
                                return (precioConPais / tipoCambio).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            })()}
                        </Text>
                      </View>
                      
                      <View style={{display: "flex", alignItems: "center", justifyContent: "center", width: "94px", height: "56px", border: 0.4, borderColor: grayBorder}}>
                        <Text style={{fontFamily: "OpenSans", fontWeight: "medium", fontSize: "10px", color: black, textAlign: "center" }}>
                          {moneda + " "}
                          {(() => {
                            let finalPrice = 0;
                            
                            if (e?.customPriceActive) {
                              if (!isNaN(e.customPrice) && !isNaN(e.numeroItems)) {
                                finalPrice = e.customPrice * e.numeroItems;
                                if (e.tipoDescuento === "Porcentaje" && !isNaN(e.montoDescuento)) {
                                  finalPrice -= (finalPrice * e.montoDescuento) / 100;
                                } else if (e.tipoDescuento === "Fijo" && !isNaN(e.montoDescuento)) {
                                  finalPrice -= (e.montoDescuento * e.numeroItems);
                                }
                              }
                            } else {
                              const unitPrice = CalcularPrecioPais({
                                precio: e.servicio?.preciosUnitarios?.find(
                                  (pU) => pU.plan.id === e.planServicio.id
                                )?.precio,
                                multiplicador: ObtenerMultiplicador({
                                    pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
                                    paises: paises
                                })
                             });
                              
                              if (!isNaN(unitPrice) && !isNaN(e.numeroItems)) {
                                finalPrice = unitPrice * e.numeroItems;
                                if (e.tipoDescuento === "Porcentaje" && !isNaN(e.montoDescuento)) {
                                  finalPrice -= (finalPrice * e.montoDescuento) / 100;
                                } else if (e.tipoDescuento === "Fijo" && !isNaN(e.montoDescuento)) {
                                  finalPrice -= (e.montoDescuento * e.numeroItems);
                                }
                              }
                            }
                            
                            return (finalPrice / tipoCambio).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            });
                          })()}
                        </Text>
                      </View>

                    </View>
                  ))}
                </View>

              </View>

              { /* Tabla pagos */}
              <View style={{ 
                display: "flex", 
                flexDirection: "col", 
                width: "746px"
              }}>

                { /* Contenedor de las tablas */}
                <View style={{ 
                  display: "flex", 
                  flexDirection: "row", 
                  gap: "32px",
                }}>

                  {/* Condiciones de pago */}
                  <View style={{ 
                    display: "flex", 
                    flexDirection: "col",
                    justifyContent: "space-between",
                    width: "466px",
                    gap: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "semibold", 
                      fontSize: "16px",
                    }}>
                      Condiciones de pago
                    </Text>

                    {/* Tabla pagos */}
                    <View style={{ 
                      display: "flex", 
                      flexDirection: "col", 
                      alignItems: "center",
                      width: "100%",
                    }}>

                      {/* Table head */}
                      <View style={{ display: "flex", flexDirection: "row"}}>
                        
                        <View style={{ // Descripcion
                          width: "155.33px", 
                          backgroundColor: black,
                          borderColor: grayBorder, 
                          borderWidth: 0.4,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          borderTopLeftRadius: 8,
                          justifyContent: "center",
                          paddingVertical: "12px",
                        }}>
                          <Text style={{ 
                            fontFamily: "OpenSans", 
                            fontWeight: "medium", 
                            fontSize: "12px", 
                            color: white,
                            textAlign: "center"
                          }}>
                            Cantidad
                          </Text>
                        </View>

                        <View style={{ // Monto a pagar
                          width: "155.33px", 
                          backgroundColor: darkBlue,
                          borderColor: grayBorder, 
                          borderWidth: 0.4,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingVertical: "12px",
                        }}>
                          <Text style={{ 
                            fontFamily: "OpenSans", 
                            fontWeight: "medium", 
                            fontSize: "12px", 
                            color: white,
                            textAlign: "center"
                          }}>
                            Monto a pagar
                          </Text>
                        </View>

                        <View style={{ // Fecha límite
                          width: "155.33px", 
                          backgroundColor: darkBlue,
                          borderColor: grayBorder, 
                          borderWidth: 0.4,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          borderTopRightRadius: 8,
                          justifyContent: "center",
                          paddingVertical: "12px",
                        }}>
                          <Text style={{ 
                            fontFamily: "OpenSans", 
                            fontWeight: "medium", 
                            fontSize: "12px", 
                            color: white,
                            textAlign: "center"
                          }}>
                            Fecha límite
                          </Text>
                        </View>

                      </View>
                      
                      {/* Rows */}
                      <View style={{ 
                        display: "flex", 
                        flexDirection: "column",
                        borderColor: grayBorder,
                        borderWidth: 0.4,
                        borderBottomLeftRadius: 8,
                        borderBottomRightRadius: 8,
                        overflow: "hidden"
                      }}>                        
                        {pagosList.map((e, index) => (
                          <View style={{ 
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "row", 
    

                            backgroundColor: index % 2 === 0 ? "white" : gray,
                            ...(index === serviciosList.length - 1 && {
                              borderBottomLeftRadius: 8,
                              borderBottomRightRadius: 8
                            })
                          }}> 

                            <View style={{ 
                              display: "flex", 
                              alignItems: "center", 
                              justifyContent: "center", 
                              width: "155.33px", 
                              height: "40px",
                              border: 0.4, 
                              borderColor: grayBorder,
                            }}>
                              <Text style={{ 
                                textAlign: "center", 
                                fontFamily: "OpenSans", 
                                fontWeight: "medium", 
                                fontSize: "10px", 
                                color: black
                              }}>
                                {e?.descripcion}
                              </Text>
                            </View>

                            <View style={{ 
                              display: "flex", 
                              alignItems: "center", 
                              justifyContent: "center", 
                              width: "155.33px", 
                              height: "40px",
                              border: 0.4, 
                              borderColor: grayBorder,
                            }}>
                              <Text style={{ 
                                textAlign: "center", 
                                fontFamily: "OpenSans", 
                                fontWeight: "medium", 
                                fontSize: "10px", 
                                color: black
                              }}>
                                {/* {moneda + " "} 
                                {(e.precio).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })} */}
                                {moneda + " "} 
                                {(e.precio / tipoCambio).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                              </Text>
                            </View>

                            <View style={{ 
                              display: "flex",
                              alignItems: "center", 
                              justifyContent: "center", 
                              width: "155.33px",
                              height: "40px",
                              border: 0.4, 
                              borderColor: grayBorder,
                            }}>
                              <Text style={{ 
                                textAlign: "center", 
                                fontFamily: "OpenSans", 
                                fontWeight: "medium", 
                                fontSize: "10px", 
                                color: black
                              }}>
                                {e.fechaLimite && FormatDateString(e?.fechaLimite)}
                              </Text>
                            </View>
                          </View>
                        ))}
                      </View>

                    </View>
                  </View>
                  
                  {/* Cuenta total */}
                  <View style={{ 
                    display: "flex", 
                    flexDirection: "col",
                    width: "248px",
                    gap: "16px"
                  }}>
                    <Text style={{ 
                      fontFamily: "OpenSans", 
                      fontWeight: "semibold", 
                      fontSize: "16px",
                    }}>
                      Cuenta total
                    </Text>

                    {/* Tabla cuenta total */}
                    <View style={{ 
                      display: "flex", 
                      flexDirection: "col",
                      borderColor: grayBorder,
                      borderWidth: 0.4,
                      borderRadius: 8,
                      overflow: "hidden"
                    }}>


                      {/* Rows */}
                      <View style={{ display: "flex", flexDirection: "column" }}>
                        {/* Subtotal */}
                        <View style={{ 
                          display: "flex", 
                          flexDirection: "row",
                          backgroundColor: "white",
                          borderBottomWidth: 0.4,
                          borderBottomColor: grayBorder,
                          borderTopRightRadius: 8,
                          borderTopLeftRadius: 8,
                        }}>
                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px",
                            borderRightWidth: 0.4,
                            borderRightColor: grayBorder
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "medium", 
                              fontSize: "10px", 
                              color: black,
                              textAlign: "center"
                            }}>
                              Subtotal sin descuento
                            </Text>
                          </View>

                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px"
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "bold", 
                              fontSize: "10px", 
                              color: black,
                              textAlign: "center"
                            }}>
                              {/* Versión antigua */}
                              {/* {serviciosList
                                .reduce((acc, value) => {
                                  const precio =
                                    value.customPriceActive
                                      ? value.customPrice * value.numeroItems
                                      : value.servicio.preciosUnitarios?.find(
                                          (pU) => pU.plan.id === value.planServicio.id
                                      )?.precio * value.numeroItems || 0;
                                  return acc + precio;
                                }, 0).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })
                              } */}

                              {/* Versión semi-antigua */}
                              {/* {(serviciosList
                                .reduce((acc, value) => {
                                  const precio =
                                    value.customPriceActive
                                      ? value.customPrice * value.numeroItems
                                      : CalcularPrecioPais({
                                          precio: value.servicio.preciosUnitarios?.find(
                                            (pU) => pU.plan.id === value.planServicio.id
                                          )?.precio,
                                          multiplicador: ObtenerMultiplicador({
                                            pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
                                            paises: paises
                                          })
                                        }) * value.numeroItems || 0;
                                  return acc + precio;
                                }, 0) / tipoCambio).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })
                              } */}

                              {moneda + " "}
                              {serviciosList
                                .reduce((acc, servicio) => {
                                    // Calcular precio unitario del servicio
                                    let precioUnitario = 0;
                                    
                                    if (servicio.customPriceActive) {
                                        // Si tiene precio personalizado, usar ese
                                        precioUnitario = servicio.customPrice;
                                    } else {
                                        // Si no, buscar en precios unitarios del plan
                                        const precioPlan = servicio.servicio.preciosUnitarios?.find(
                                            (pU) => pU.plan.id === servicio.planServicio.id
                                        );
                                        precioUnitario = precioPlan?.precio || 0;
                                    }
                                    
                                    // Calcular precio total del servicio (precio unitario * cantidad)
                                    const precioTotal = precioUnitario * servicio.numeroItems;
                                    
                                    // Aplicar multiplicador según el país
                                    const precioConPais = servicio.customPriceActive
                                    ? precioTotal
                                    : CalcularPrecioPais({
                                        precio: precioTotal,
                                        multiplicador: ObtenerMultiplicador({
                                            pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
                                            paises: paises
                                        })
                                    });
                                    
                                    return acc + precioConPais / tipoCambio;
                                }, 0)
                                .toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                              }
                            </Text>
                          </View>
                        </View>

                        {/* Descuento */}
                        <View style={{ 
                          display: "flex", 
                          flexDirection: "row",
                          backgroundColor: gray,
                          borderBottomWidth: 0.4,
                          borderBottomColor: grayBorder
                        }}>
                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px",
                            borderRightWidth: 0.4,
                            borderRightColor: grayBorder
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "medium", 
                              fontSize: "10px", 
                              color: black,
                              textAlign: "center"
                            }}>
                              Descuento (?)
                            </Text>
                          </View>

                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px"
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "bold", 
                              fontSize: "10px", 
                              color: black,
                              textAlign: "center"
                            }}>
                              {moneda + " "}
                              {(() => {
                                return (descuentoTotal / tipoCambio).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                });
                              })()}
                            </Text>
                          </View>
                        </View>

                        {/* Total sin IGV */}
                        <View style={{ 
                          display: "flex", 
                          flexDirection: "row",
                          backgroundColor: "white",
                          borderBottomWidth: 0.4,
                          borderBottomColor: grayBorder
                        }}>
                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px",
                            borderRightWidth: 0.4,
                            borderRightColor: grayBorder
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "medium", 
                              fontSize: "10px", 
                              color: black,
                              textAlign: "center"
                            }}>
                              Total sin IGV
                            </Text>
                          </View>

                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px"
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "bold", 
                              fontSize: "10px", 
                              color: black,
                              textAlign: "center"
                            }}>
                              {/* {moneda + " "} {(() => {
                                return (totalSinDescuento).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                });
                              })()} */}
                              {moneda + " "}
                              {(serviciosList
                                .reduce((acc, value) => {
                                  const precio =
                                    value.customPriceActive
                                      ? value.customPrice * value.numeroItems
                                      : CalcularPrecioPais({
                                          precio: value.servicio.preciosUnitarios?.find(
                                            (pU) => pU.plan.id === value.planServicio.id
                                          )?.precio,
                                          multiplicador: ObtenerMultiplicador({
                                            pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
                                            paises: paises
                                          })
                                        }) * value.numeroItems || 0;
                                  return acc + precio;
                                }, 0) / tipoCambio - descuentoTotal / tipoCambio).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })
                              }
                            </Text>
                          </View>
                        </View>

                        {/* Monto IGV */}
                        <View style={{ 
                          display: "flex", 
                          flexDirection: "row",
                          backgroundColor: gray,
                          borderBottomWidth: 0.4,
                          borderBottomColor: grayBorder
                        }}>
                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px",
                            borderRightWidth: 0.4,
                            borderRightColor: grayBorder
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "medium", 
                              fontSize: "10px", 
                              color: black,
                              textAlign: "center"
                            }}>
                              {igv ? "Si" : "Monto IGV"}
                            </Text>
                          </View>

                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px"
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "bold", 
                              fontSize: "10px", 
                              color: darkBlue,
                              textAlign: "center"
                            }}>
                              {moneda + " "}
                              {(() => {
                                return (igvTotal / tipoCambio).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                });
                              })()}
                            </Text>
                          </View>
                        </View>

                        {/* Total */}
                        <View style={{ 
                          display: "flex", 
                          flexDirection: "row",
                     
                        }}>
                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px",
                            borderRightWidth: 0.4,
                            borderRightColor: grayBorder,
                            backgroundColor: black
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "bold", 
                              fontSize: "10px", 
                              color: "white",
                              textAlign: "center"
                            }}>
                              Total
                            </Text>
                          </View>

                          <View style={{ 
                            width: "124px", 
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingVertical: "12px",
                            backgroundColor: darkBlue
                          }}>
                            <Text style={{ 
                              fontFamily: "OpenSans", 
                              fontWeight: "bold", 
                              fontSize: "10px", 
                              color: "white",
                              textAlign: "center"
                            }}>
                              {/* {moneda === "PEN" ? "S/. " : "$"} {(totalSinDescuento + igvTotal).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })} */}
                              {moneda + " "}
                              {((serviciosList
                                .reduce((acc, value) => {
                                  const precio =
                                    value.customPriceActive
                                      ? value.customPrice * value.numeroItems
                                      : CalcularPrecioPais({
                                          precio: value.servicio.preciosUnitarios?.find(
                                            (pU) => pU.plan.id === value.planServicio.id
                                          )?.precio,
                                          multiplicador: ObtenerMultiplicador({
                                            pais: cotizacionData?.cliente?.pais || cotizacionData?.lead?.country,
                                            paises: paises
                                          })
                                        }) * value.numeroItems || 0;
                                  return acc + precio;
                                }, 0) / tipoCambio - descuentoTotal / tipoCambio) + igvTotal / tipoCambio).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })
                              }
                            </Text>
                          </View>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </View>

              

            </View>

            {/* Sección de términos de pago */}
            <View style={{ 
              display: "flex", 
              flexDirection: "col", 
              paddingHorizontal: "48px", 
              paddingVertical: "32px",
              gap: "32px"                           
            }}>

              {/* Cuentas bancarias */}
              <View style={{ 
                borderRadius: "8px",
                borderWidth: 1,
                borderColor: blue,
                display: "flex", 
                flexDirection: "col", 
                width: "746px",
                backgroundColor: gray,
                justifyContent: "space-between",
                paddingBottom: "24px"
              }}>

                {/* Cabecera */}
                <View style={{
                  width: "187px",
                  height: "36px",
                  backgroundColor: blue,
                  paddingHorizontal: "24px",
                  paddingVertical: "4px",
                  textAlign: "center",
                  justifyContent: "center",
                  borderTopLeftRadius: "6px",
                  borderBottomRightRadius: "8px",
                }}>
                  <Text style={{
                    fontFamily: "OpenSans",
                    fontWeight: "semibold",
                    fontSize: "16px",
                    color: white,
                  }}>
                    Términos de pago
                  </Text>
                </View>

                {/* Contenedores */}
                <View style={{ width: "100%", marginTop: "24px", paddingHorizontal: "24px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>


                  <View style={{ width: "408px", display: "flex", flexDirection: "col", gap: "24px" }}>
                    
                    <View style={{ width: "100%", display: "flex", flexDirection: "row", gap: "8px" }}>
                      <Image source={ArrowAllsavfe} style={{ width: 16, height: 16 }} />
                      <Text style={{ color: black, fontFamily: "OpenSans", fontWeight: "medium", fontSize: "12px" }}>
                        El cliente realizará el pago en las fechas consignadas en esta {"\n"}cotización                      
                      </Text>
                    </View>

                    <View style={{ width: "100%", display: "flex", flexDirection: "row", gap: "8px" }}>
                      <Image source={ArrowAllsavfe} style={{ width: 16, height: 16 }} />
                      <Text style={{ color: black, fontFamily: "OpenSans", fontWeight: "medium", fontSize: "12px" }}>
                        El cliente enviará la cotización firmada al correo {"\n"}ventas@monstruocreativo.com
                      </Text>
                    </View>

                    <View style={{ width: "100%", display: "flex", flexDirection: "row", gap: "8px" }}>
                      <Image source={ArrowAllsavfe} style={{ width: 16, height: 16 }} />
                      <Text style={{ color: black, fontFamily: "OpenSans", fontWeight: "medium", fontSize: "12px" }}>
                        El cliente al firmar esta cotización acepta las Políticas de: pagos, {"\n"}servicio, privacidad, términos y condiciones                      
                      </Text>
                    </View>
                  </View>

                  <View style={{ width: "256px", 
                    backgroundColor: white, 
                    height: "100%", 
                    paddingHorizontal: "24px", 
                    display: "flex", 
                    flexDirection: "col", 
                    gap: "16px",
                    paddingVertical: "16px", 
                    borderRadius: "8px" 
                  }}>

                    {/* Política de pago */}
                    <View style={{ 
                      width: "224px",
                      display: "flex", 
                      flexDirection: "row", 
                      alignItems: "center", 
                      justifyContent: "start", 
                      gap: "4px"
                    }}>
                      
                      <Text style={{ // Título
                        color: black, 
                        width: "148px",
                        fontFamily: "OpenSans", 
                        fontWeight: "medium", 
                        fontSize: "12px",
                      }}>
                        Política de pago
                      </Text>
                      
                      <Text style={{
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        fontSize: "12px",
                        color: black,
                        width: "3px"
                      }}>
                        :
                      </Text>

                      <Text style={{
                        fontFamily: "OpenSans",
                        fontWeight: "medium",
                        fontSize: "12px",
                        color: darkBlue,
                        width: "20px"
                      }}>
                        <Link href="https://www.allsavfe.com/terminos-y-condiciones-2/">
                          Ver
                        </Link>
                      </Text>

                      <Image source={ClipAllSavfe} style={{ width: 14, height: 14 }} />

                    </View>

                    {/* Política de servicio */}
                    <View style={{ 
                      width: "224px",
                      display: "flex", 
                      flexDirection: "row", 
                      alignItems: "center", 
                      justifyContent: "start", 
                      gap: "4px"
                    }}>
                      
                      <Text style={{ // Título
                        color: black, 
                        width: "148px",
                        fontFamily: "OpenSans", 
                        fontWeight: "medium", 
                        fontSize: "12px",
                      }}>
                        Política de servicio
                      </Text>
                      
                      <Text style={{
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        fontSize: "12px",
                        color: black,
                        width: "3px"
                      }}>
                        :
                      </Text>

                      <Text style={{
                        fontFamily: "OpenSans",
                        fontWeight: "medium",
                        fontSize: "12px",
                        color: darkBlue,
                        width: "20px"
                      }}>
                        <Link href="https://www.allsavfe.com/terminos-y-condiciones-2/">
                          Ver
                        </Link>
                      </Text>

                      <Image source={ClipAllSavfe} style={{ width: 14, height: 14 }} />

                    </View>

                    {/* Política de privacidad */}
                    <View style={{ 
                      width: "224px",
                      display: "flex", 
                      flexDirection: "row", 
                      alignItems: "center", 
                      justifyContent: "start", 
                      gap: "4px"
                    }}>
                      
                      <Text style={{ // Título
                        color: black, 
                        width: "148px",
                        fontFamily: "OpenSans", 
                        fontWeight: "medium", 
                        fontSize: "12px",
                      }}>
                        Política de privacidad
                      </Text>
                      
                      <Text style={{
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        fontSize: "12px",
                        color: black,
                        width: "3px"
                      }}>
                        :
                      </Text>

                      <Text style={{
                        fontFamily: "OpenSans",
                        fontWeight: "medium",
                        fontSize: "12px",
                        color: darkBlue,
                        width: "20px"
                      }}>
                        <Link href="https://www.allsavfe.com/terminos-y-condiciones-2/">
                          Ver
                        </Link>
                      </Text>

                      <Image source={ClipAllSavfe} style={{ width: 14, height: 14 }} />

                    </View>

                    {/* Términos y condiciones */}
                    <View style={{ 
                      width: "224px",
                      display: "flex", 
                      flexDirection: "row", 
                      alignItems: "center", 
                      justifyContent: "start", 
                      gap: "4px"
                    }}>
                      
                      <Text style={{ // Título
                        color: black, 
                        width: "148px",
                        fontFamily: "OpenSans", 
                        fontWeight: "medium", 
                        fontSize: "12px",
                      }}>
                        Términos y condiciones
                      </Text>
                      
                      <Text style={{
                        fontFamily: "Poppins",
                        fontWeight: "bold",
                        fontSize: "12px",
                        color: black,
                        width: "3px"
                      }}>
                        :
                      </Text>

                      <Text style={{
                        fontFamily: "OpenSans",
                        fontWeight: "medium",
                        fontSize: "12px",
                        color: darkBlue,
                        width: "20px"
                      }}>
                        <Link href="https://www.allsavfe.com/terminos-y-condiciones-2/">
                          Ver
                        </Link>
                      </Text>

                      <Image source={ClipAllSavfe} style={{ width: 14, height: 14 }} />

                    </View>

                  </View>


                </View>
                
              </View>
            </View>

            {/* Sección de resumen de servicios */}
            <View style={{ 
              display: "flex", 
              flexDirection: "col",
              paddingVertical: "48px",
            }}>
              <View style={{ display: "flex", flexDirection: "column", paddingHorizontal: "48px", paddingVertical: "16px"}}>

                {/* Título */}
                <Text style={{ fontFamily: "Poppins", fontSize: "20px", fontWeight: "bold", color: black, marginBottom: "32px" }}>
                  Resumen de servicios
                </Text>

                {/* Mapeo de servicios */}
                {serviciosList.map(item => (
                  <View style={{ display: "flex", flexDirection: "column", marginBottom: "32px", gap: "16px" }} key={item.id}>
                    
                    <View style={{ display: "flex", flexDirection: "col", justifyContent: "space-between", gap: "8px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "16px", fontWeight: "medium", color: black }}>
                        {sanitizeNombreServicioPdf(item.servicio.name)}
                      </Text>
                      <View style={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", gap: "8px" }}>
                        <Image source={ArrowAllsavfe} style={{ width: 16, height: 16 }} />
                        <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "light", color: black }}>
                          Plan: {sanitizeNombreServicioPdf(item.planServicio.name)}
                        </Text>
                      </View>
                    </View>

                    {/* Tabla */ }
                    <View style={{ display: "flex", flexDirection: "col", borderWidth: 0.4, borderColor: grayBorder, borderRadius: "8px", overflow: "hidden" }}>
                        {/* Encabezado de la tabla */}
                      <View style={{ display: "flex", flexDirection: "row" }}>
                        
                        <View style={{ 
                          display: "flex", 
                          justifyContent: "center", 
                          paddingHorizontal: "16px", 
                          width: "346px",
                          height: "40px",
                          backgroundColor: black, 
                          borderColor: grayBorder, 
                          borderWidth: 0.4 
                        }}>
                          <Text style={{ 
                            fontFamily: "OpenSans", 
                            fontWeight: "semibold", 
                            fontSize: "14px", 
                            color: "white",
                            textAlign: "center"
                          }}>
                            Descripción del servicio
                          </Text>
                        </View>

                        <View style={{ 
                          display: "flex", 
                          justifyContent: "center", 
                          paddingHorizontal: "16px", 
                          width: "200px",
                          height: "40px",
                          backgroundColor: darkBlue, 
                          borderColor: grayBorder, 
                          borderWidth: 0.4 
                        }}>
                          <Text style={{ 
                            fontFamily: "OpenSans", 
                            fontWeight: "semibold", 
                            fontSize: "14px", 
                            color: "white",
                            textAlign: "center"
                          }}>
                            Detalles específicos
                          </Text>
                        </View>

                        <View style={{ 
                          display: "flex", 
                          justifyContent: "center", 
                          paddingHorizontal: "16px", 
                          width: "200px",
                          height: "40px",
                          backgroundColor: darkBlue, 
                          borderColor: grayBorder, 
                          borderWidth: 0.4 
                        }}>
                          <Text style={{ 
                            fontFamily: "OpenSans", 
                            fontWeight: "semibold", 
                            fontSize: "14px", 
                            color: "white",
                            textAlign: "center"
                          }}>
                            Comentarios vendedor
                          </Text>
                        </View>
                      </View>

                      {/* Cuerpo de la tabla */}
                      <View style={{ display: "flex", flexDirection: "row" }}>
                        <View style={{ display: "flex", flexDirection: "col" }}>
                          {item.customDescriptionActive ? (
                            parseDescription(item.customDescriptionText).map((service, index) => (
                              <View style={{ display: "flex", flexDirection: "row" }} key={index}>
                                <View style={{ display: "flex", justifyContent: "center", width: "346px", paddingVertical: "10px", backgroundColor: index % 2 !== 0 ? gray : "white", borderWidth: 0.4, borderColor: grayBorder, paddingHorizontal: "16px" }}>
                                  <Text style={{ fontFamily: "OpenSans", fontWeight: "light", fontSize: "12px", color: black }}>
                                    {service.key}
                                  </Text>
                                </View>
                                <View style={{ display: "flex", justifyContent: "center", width: "200px", backgroundColor: index % 2 !== 0 ? gray : "white", borderWidth: 0.4, borderColor: grayBorder, paddingHorizontal: "16px" }}>
                                  <Text style={{ fontFamily: "OpenSans", fontWeight: "light", fontSize: "12px", color: black }}>
                                    {service.value}
                                  </Text>
                                </View>
                              </View>
                            ))
                          ) : (
                            parseDescription(item.planServicio.descripcion).map((service, index) => (
                              <View style={{ display: "flex", flexDirection: "row" }} key={index}>
                                <View style={{ display: "flex", justifyContent: "center", width: "346px", paddingVertical: "10px", backgroundColor: index % 2 !== 0 ? gray : "white", borderWidth: 0.4, borderColor: grayBorder, paddingHorizontal: "16px" }}>
                                  <Text style={{ fontFamily: "OpenSans", fontWeight: "light", fontSize: "12px", color: black }}>
                                    {service.key}
                                  </Text>
                                </View>
                                <View style={{ display: "flex", justifyContent: "center", width: "200px", backgroundColor: index % 2 !== 0 ? gray : "white", borderWidth: 0.4, borderColor: grayBorder, paddingHorizontal: "16px" }}>
                                  <Text style={{ fontFamily: "OpenSans", fontWeight: "light", fontSize: "12px", color: black }}>
                                    {service.value}
                                  </Text>
                                </View>
                              </View>
                            ))
                          )}
                        </View>

                        <View style={{ width: "200px", paddingHorizontal: "16px", paddingVertical: "10px", borderWidth: 0.4, borderColor: grayBorder }}>
                          <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: black, marginBottom: "4px" }}>
                            {item.comentarioVendedor ? item.comentarioVendedor : "No hay comentarios adicionales"}
                          </Text>
                          
                          {/* <View style={{ marginTop: "8px" }}>
                            <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                Precio fijo:
                              </Text>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                {(cotizacionData?.moneda === "PEN" ? "S/. " : "$") + (item?.customPriceActive ? item.customPrice : item.servicio.preciosUnitarios?.find(pU => pU.plan.id === item.planServicio.id)?.precio || 0).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                              </Text>
                            </View>
                            <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                Descuento:
                              </Text>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                {item?.tipoDescuento === "Porcentaje" 
                                  ? (!isNaN(Number(item?.montoDescuento))
                                    ? `${Number(item.montoDescuento)} %`
                                    : "-")
                                  : (cotizacionData?.moneda && !isNaN(Number(item?.montoDescuento))
                                    ? `${cotizacionData.moneda === "PEN" ? "S/. " : "$"} ${Number(item.montoDescuento).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}`
                                  : "-"
                                )}
                              </Text>
                            </View>
                            <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                Precio final x unidad:
                              </Text>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                {(cotizacionData?.moneda === "PEN" ? "S/. " : "$") + ((item?.customPriceActive ? item.customPrice : item.servicio.preciosUnitarios?.find(pU => pU.plan.id === item.planServicio.id)?.precio || 0) - (item?.tipoDescuento === "Porcentaje" ? ((item?.customPriceActive ? item.customPrice : item.servicio.preciosUnitarios?.find(pU => pU.plan.id === item.planServicio.id)?.precio || 0) * (Number(item?.montoDescuento) || 0) / 100) : (Number(item?.montoDescuento) || 0))).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                              </Text>
                            </View>
                            <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                Cantidad:
                              </Text>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                {item.numeroItems}
                              </Text>
                            </View>
                            <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                              {"---------------------------------"}
                            </Text>
                            <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: "4px" }}>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                Total:
                              </Text>
                              <Text style={{ fontFamily: "Poppins", fontSize: "10px", fontWeight: "light", color: darkBlue }}>
                                {(cotizacionData?.moneda === "PEN" ? "S/. " : "$") + CalculateFinalPrice(item, allServiciosList).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                              </Text>
                            </View>
                          </View> */}
                        </View>
                      </View>

                    </View>
                  </View>
                ))}

              </View>
            </View>

            {/* Enlaces adicionales */}
            <View style={{ display: "flex", flexDirection: "column", paddingHorizontal: "48px", paddingVertical: "48px", height: "261px", marginTop: "auto", gap: "32px"}}>
              
              <Text style={{ fontFamily: "Poppins", fontSize: "24px", fontWeight: "bold", color: black, marginBottom: "16px", textAlign: "center" }}>
                Enlaces adicionales
              </Text>

              <View style={{ display: "flex", flexDirection: "row", height: "104px", justifyContent: "space-between", alignItems: "center" }}>

                  {/* Casos de Éxito */}
                  <View style={{ display: "flex", flexDirection: "column", width: "235px", height: "104px", gap: "12px" }}>

                    <View style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
                      <Image source={ClipAllSavfe} style={{ width: 16, height: 16 }} />
                      <Text style={{ fontFamily: "OpenSans", fontSize: "16px", fontWeight: "medium", color: blue }}>
                        Casos de Éxito
                      </Text>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                        Google Ads
                      </Text>

                      <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                        :
                      </Text>

                      <Link src="https://www.youtube.com/watch?v=9OSdtnjKrQ4&list=PLTZlHKHffVTYC9wsIC6dYlB2-nBqipx1f&pp=iAQB">
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                          https://www.youtube.com
                        </Text>
                      </Link>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                        Meta Ads
                      </Text>

                      <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                        :
                      </Text>

                      <Link src="https://www.youtube.com/watch?v=qUXb5UH6Yug&list=PLTZlHKHffVTaB8qnRcqb9vhPR_jHCHsgy&pp=iAQB">
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                          https://www.youtube.com
                        </Text>
                      </Link>
                    </View>

                      <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                        Linkedin ads
                        </Text>

                        <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                          :
                        </Text>

                        <Link src="https://www.youtube.com/watch?v=OwCBApwvIw0&list=PLTZlHKHffVTYynZk8hFUIob9MwFWUzIsu&pp=iAQB">
                          <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                            https://www.youtube.com
                          </Text>
                        </Link>
                      </View>



                  </View>

                  {/* Testimonios de clientes */}
                  <View style={{ display: "flex", flexDirection: "column", width: "235px", height: "104px", gap: "12px" }}>

                    <View style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
                      <Image source={ClipAllSavfe} style={{ width: 16, height: 16 }} />
                      <Text style={{ fontFamily: "OpenSans", fontSize: "16px", fontWeight: "medium", color: blue }}>
                        Testimonios de clientes
                      </Text>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                        Google Ads
                      </Text>

                      <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                        :
                      </Text>

                      <Link src="https://www.youtube.com/watch?v=9OSdtnjKrQ4&list=PLTZlHKHffVTYC9wsIC6dYlB2-nBqipx1f&pp=iAQB">
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                          https://www.youtube.com
                        </Text>
                      </Link>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                        Meta Ads
                      </Text>

                      <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                        :
                      </Text>

                      <Link src="https://www.youtube.com/watch?v=qUXb5UH6Yug&list=PLTZlHKHffVTaB8qnRcqb9vhPR_jHCHsgy&pp=iAQB">
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                          https://www.youtube.com
                        </Text>
                      </Link>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                      Linkedin ads
                      </Text>

                      <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                        :
                      </Text>

                      <Link src="https://www.youtube.com/watch?v=OwCBApwvIw0&list=PLTZlHKHffVTYynZk8hFUIob9MwFWUzIsu&pp=iAQB">
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                          https://www.youtube.com
                        </Text>
                      </Link>
                    </View>

                  </View>

                  {/* Webs de referencia */}
                  <View style={{ display: "flex", flexDirection: "column", width: "235px", height: "104px", gap: "12px" }}>

                    <View style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "4px" }}>
                      <Image source={ClipAllSavfe} style={{ width: 16, height: 16 }} />
                      <Text style={{ fontFamily: "OpenSans", fontSize: "16px", fontWeight: "medium", color: blue }}>
                        Webs de referencia
                      </Text>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                        Google Ads
                      </Text>

                      <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                        :
                      </Text>

                      <Link src="https://www.youtube.com/watch?v=9OSdtnjKrQ4&list=PLTZlHKHffVTYC9wsIC6dYlB2-nBqipx1f&pp=iAQB">
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                          https://www.youtube.com
                        </Text>
                      </Link>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                        Meta Ads
                      </Text>

                      <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                        :
                      </Text>

                      <Link src="https://www.youtube.com/watch?v=qUXb5UH6Yug&list=PLTZlHKHffVTaB8qnRcqb9vhPR_jHCHsgy&pp=iAQB">
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                          https://www.youtube.com
                        </Text>
                      </Link>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", width: "235px", gap: "4px" }}>
                      <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "medium", color: black }}>
                      Linkedin ads
                      </Text>

                      <Text style={{ fontFamily: "Poppins", fontSize: "12px", fontWeight: "bold", color: darkBlue }}>
                        :
                      </Text>

                      <Link src="https://www.youtube.com/watch?v=OwCBApwvIw0&list=PLTZlHKHffVTYynZk8hFUIob9MwFWUzIsu&pp=iAQB">
                        <Text style={{ fontFamily: "OpenSans", fontSize: "12px", fontWeight: "light", color: black }}>
                          https://www.youtube.com
                        </Text>
                      </Link>
                    </View>

                  </View>

              </View>
            </View>

            {/* Footer */}
            <View style={{ display: "flex", justifyContent: "center", textAlign: "center", alignItems: "center", backgroundColor: blue, height: "48px" }}>
              <Text style={{ fontFamily: "OpenSans", fontSize: "12px", color: white, fontWeight: "medium" }}>
                @Allsavfe/Agencia de software
              </Text>
            </View>

          </Page>
        </Document>
      }
    </>
  )

  return (
    <ModalInDrawer
      className="max-w-5xl w-full"
      activeModal={open}
      onClose={onClose}
      title={title}
    >
      <BlobProvider document={pdf}>
        {({ blob, url, loading }) => (
          <div className="w-full h-full">
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <p>Cargando PDF...</p>
              </div>
            ) : (
              <div className="w-full h-full">
                <iframe
                  src={url}
                  className="w-full h-full min-h-screen"
                  title="PDF Viewer"
                  showToolbar={false}
                />
                <button
                  onClick={() => handleDownloadBlobPDF(blob, `${cotizacionData?.cliente?.razonSocial || cotizacionData?.lead?.leadName} - ${brandName} - ${formatDateString(cotizacionData?.createdAt)}.pdf`)}
                  className="fixed top-4 font-bold text-xs right-4 bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition-all duration-100 shadow-md"
                >
                  <div className="flex items-center gap-2">
                    Descargar PDF
                    <FaDownload />
                  </div>
                </button>
              </div>
            )}
          </div>
        )}
      </BlobProvider>
    </ModalInDrawer>
  );
}

export default PDFAllSavfe